var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10251 5.43733V10.6531C1.10251 10.7283 1.16294 10.7887 1.23814 10.7887H3.17592C3.25112 10.7887 3.31155 10.7283 3.31155 10.6531V5.35139H4.7162C4.78738 5.35139 4.84512 5.29767 4.85184 5.2265L4.98747 3.62981C4.99418 3.55058 4.93107 3.4821 4.85184 3.4821H3.31289V2.3487C3.31289 2.08281 3.52775 1.86795 3.79364 1.86795H4.87601C4.95121 1.86795 5.01164 1.80752 5.01164 1.73232V0.135631C5.01164 0.0604298 4.95121 0 4.87601 0H3.047C1.97404 0 1.10385 0.870188 1.10385 1.94315V3.48344H0.135631C0.06043 3.48344 0 3.54387 0 3.61907V5.21576C0 5.29096 0.06043 5.35139 0.135631 5.35139H1.10385V5.43599L1.10251 5.43733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.59175389c31c0f2b053b4f38b33ac02b.svg";
export { ForwardRef as ReactComponent };